module.exports = __webpack_public_path__ + "static/media/keith-maguire.ffb4ee74.jpg";